<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      Set the participant's
      <span :class="{'has-error':errors.studyVariableId}">
        <select :value="studyVariableId" name="studyVariableId" class="form-control" @change="handleChange">
          <option value="">Select Variable</option>
          <option v-for="(variable, $id) in config.studyVariablesByType['TextBasedVariable']" :value="$id">{{ variable.name }}</option>
        </select>
      </span>
      variable value to
      <span :class="{'has-error':errors.modificationType}">
        <select :value="modificationType" name="modificationType" class="form-control" @change="handleChange">
          <option value="" disabled>Select One</option>
          <option v-for="(display, $id) in availableModificationTypes" :value="$id">{{ display }}</option>
        </select>
      </span>

      <select
        v-if="modificationType === 'variable'"
        :value="modificationVariableId"
        name="modificationVariableId"
        class="form-control"
        @change="handleChange"
      >
        <option value="" selected="selected" disabled>
          Select Variable
        </option>
        <option v-for="(variable, value) in config.studyVariables" :value="value">
          {{ variable.name }}
        </option>
      </select>
      <select
        v-else-if="modificationType == 'field'"
        :value="modificationFieldExportTag"
        name="modificationFieldExportTag"
        class="form-control"
        @change="handleChange"
      >
        <option value="" selected="selected" disabled>
          Select Field
        </option>
        <option v-for="(field) in config.sourceFields" :value="field.tag">
          {{ field.tag }}
        </option>
      </select>
      <span v-else-if="modificationType == 'value'" :class="{'has-error':errors.modificationValue}">
        <input
          :value="modificationValue"
          class="form-control"
          name="modificationValue"
          type="text"
          @input="handleChange"
        >
      </span>
    </div>
  </div>
</template>

<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
  import {enumValidator} from "@/EventLogic/util";

  export default {
    extends: BaseComponent,
    props: {
      id: String,
      studyVariableId: {
        // the variable whose value will be changed
        type: [Number, String]
      },
      modificationType: {
        type: String,
        validator: enumValidator(['value', 'field', 'variable'])
      },
      modificationValue: {
        // Used by value modification types
        type: String
      },
      modificationVariableId: {
        // the variable whose value will be used to set the subject variable
        type: Number
      },
      modificationFieldExportTag: {
        // the aFormField whose value will be used to set the subject variable
        type: String
      },
    },
    computed: {
      availableModificationTypes: function() {
        var types = {
          value: 'Text',
          variable: 'Another variable\'s value'
        }

        if (this.config.sourceName) {
          types.field = 'This event\'s data';
        }

        return types;
      }

    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.isNumber(this.studyVariableId)) {
          this.errors.studyVariableId = "Please select a Variable to modify.";
        }
        if (!this.modificationType) {
          this.errors.modificationType = "Please select a modification type.";
        }
        if (this.modificationType == 'value' && !this.modificationValue) {
          this.errors.modificationValue = "Please enter text that for the new variable value.";
        }
        if (this.modificationType == 'variable' && !this.modificationVariableId) {
          this.errors.modificationVariableId = "Please select a variable.";
        }
        if (this.modificationType == 'field' && !this.modificationFieldExportTag) {
          this.errors.field = "Please select a data source field.";
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
